export const isDisabledForm = ({ submitting, invalid, waiting }) => ({
  disabled: submitting || invalid || waiting,
});

export const reduceFormErrors = arr => {
  const errors = arr.reduce(
    (acc, row) => ({ ...acc, [row.field]: row.message }),
    {},
  );

  return { ...errors, _error: errors.all };
};
